import { render } from "./UsersRibbon.vue?vue&type=template&id=5cd53f3a"
import script from "./UsersRibbon.vue?vue&type=script&lang=js"
export * from "./UsersRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.3.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__